export const EXHIBITOR = 'exhibitor'
export const EXHIBITION = 'exhibition'
export const EXHIBITED_WORK = 'exhibited_work'

/**
 * Compute filters to be given to Artlas API
 *
 * @param {String} type Type of items : exhibition, exhibitor, exhibited_work
 * @param {Object} param1 Set of params useful for computing filters
 */
export function getFiltersComputed (
  type,
  initialState,
  {
    value, order, direction,
    page, itemsPerPage,
    collection, begin, end,
    jsonFilters
  }
) {
  let filtersComputed = [...initialState]
  switch (type) {
    case EXHIBITION:
      if (Array.isArray(jsonFilters) && jsonFilters.length !== 0) {
        jsonFilters = jsonFilters.map(filter => {
          if (filter.value) {
            filter.value = filter.value.toLowerCase()
            return filter
          }
        })
        filtersComputed = filtersComputed.concat([...jsonFilters])
      } else {
        if (value) {
          filtersComputed.push({
            property: 'search',
            matchType: 'cs',
            value: value.toLowerCase()
          })
        }
        if (collection && collection !== 'all') {
          filtersComputed.push({
            property: 'id_exhibition_group_type',
            matchType: 'eq',
            value: collection
          })
        }
      }
      begin && filtersComputed.push({
        property: 'begin_year',
        matchType: 'ge',
        value: begin
      })
      end && filtersComputed.push({
        property: 'begin_year',
        matchType: 'le',
        value: end
      })
      break
    case EXHIBITOR:
    case EXHIBITED_WORK:
      if (Array.isArray(jsonFilters) && jsonFilters.length !== 0) {
        jsonFilters = jsonFilters.map(filter => {
          if (filter.value) {
            filter.value = filter.value.toLowerCase()
            return filter
          }
        })
        filtersComputed = filtersComputed.concat([...jsonFilters])
      } else {
        if (value) {
          filtersComputed.push({
            property: 'search',
            matchType: 'cs',
            value: value.toLowerCase()
          })
        }
      }
      begin && filtersComputed.push({
        property: 'begin_date',
        matchType: 'ge',
        value: begin
      })
      end && filtersComputed.push({
        property: 'begin_date',
        matchType: 'le',
        value: end + '-12-31'
      })
      break
  }
  return filtersComputed
}



// WEBPACK FOOTER //
// ./src/services/filters.js